import React, { Component } from 'react'
import StartForm from './StartForm'


export default class Starter extends Component {
 
  render() {
    return (
      <div style={{width:'100%'}}>
        <StartForm />
      </div>
    )
  }
}
